import script from "./AvatarUploadModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AvatarUploadModal.vue?vue&type=script&setup=true&lang=ts"

import "./AvatarUploadModal.vue?vue&type=style&index=0&id=072822f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-072822f2"]])

export default __exports__